import * as React from "react";
import { css, keyframes } from "@emotion/core";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

const skeletonGradient = css`
  background: linear-gradient(90deg, #252c35 0%, #303a45 50%, #252c35 100%);
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s ease-in-out infinite;
`;

const titleWidths = [22, 18, 26, 20, 24, 19, 21, 23, 17, 25, 20, 22];
const snippetWidths = [68, 54, 72, 60, 66, 58, 64, 70, 55, 69, 62, 65];

const SearchSkeleton = () => (
  <div
    css={css`
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    `}
  >
    {Array.from({ length: 12 }).map((_, idx) => (
      <div
        key={idx}
        css={css`
          padding: 0.75rem;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          gap: 0.375rem;
        `}
      >
        <div
          css={css`
            height: 14px;
            width: ${titleWidths[idx % titleWidths.length]}%;
            border-radius: 4px;
            ${skeletonGradient};
          `}
        />
        <div
          css={css`
            height: 12px;
            width: 100%;
            border-radius: 4px;
            ${skeletonGradient};
          `}
        />
        <div
          css={css`
            height: 12px;
            width: ${snippetWidths[idx % snippetWidths.length]}%;
            border-radius: 4px;
            ${skeletonGradient};
          `}
        />
      </div>
    ))}
  </div>
);

export default SearchSkeleton;

